export const HospitalType = ['Hospital', 'Hospital Maternidade'];
